import request from '@/utils/requestAxios'

// get分页查询
export function getList(params) {
  return request({
    url: '/eventTrack',
    method: 'get',
    params: params
  })
}

export function getOpenidInfoHopper(openid) {
  return request({
    url: '/eventTrack/openidInfoHopper/' + openid,
    method: 'get',
  })
}

export function getBoard() {
  return request({
    url: '/eventTrack/dataBoard',
    method: 'get'
  })
}

export function exportExcel(params) {
  return request({
    url: '/eventTrack/exportExcel',
    method: 'post',
    responseType: 'blob',
    data: params
  })
}
